import React from 'react';
import { useLang } from './LanguageContext';
import { SUPPORTED, LANG_LABELS } from './translations';

// #1107 — shared language switcher for the public auth surfaces
// (signup / login). The landing page keeps its own CSS-styled switcher,
// but all three render the SAME canonical SUPPORTED list + LANG_LABELS
// map. This variant carries self-contained inline styles so it can drop
// onto any page without depending on that page's stylesheet.
//
// Selecting a language calls setLang, which persists it (LanguageContext
// → localStorage), so a visitor who lands directly on /signup keeps their
// choice across a refresh — the core of the #1107 repro.
export default function LanguageSwitcher({ style }) {
  const { lang, setLang } = useLang();
  return (
    <div
      role="group"
      aria-label="Language"
      style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center', marginBottom: 24, ...style }}
    >
      {SUPPORTED.map((l) => {
        const active = l === lang;
        return (
          <button
            key={l}
            type="button"
            lang={l}
            aria-pressed={active}
            onClick={() => setLang(l)}
            style={{
              background: active ? '#E8845A' : 'none',
              border: `1px solid ${active ? '#E8845A' : 'rgba(0,0,0,0.12)'}`,
              borderRadius: 20,
              padding: '5px 14px',
              fontFamily: 'inherit',
              fontSize: '0.8rem',
              fontWeight: active ? 600 : 400,
              color: active ? '#fff' : '#666',
              cursor: 'pointer',
              transition: 'border-color 0.2s, color 0.2s, background 0.2s',
            }}
          >
            {LANG_LABELS[l]}
          </button>
        );
      })}
    </div>
  );
}
